import { Cog, Filter, Package, Plug, Zap } from "lucide-react";
import { Category } from "../types";

export const categories: Category[] = [
  {
    id: '1',
    name: 'Lights',
    description: 'Premium headlights, tail lights, work lamps, fog lights, and auxiliary lighting engineered for heavy machinery reliability.',
    icon: <Zap size={32} />,
    count: 30,
    image: 'asus_lights_pdtefo.webp',
    featured: true
  },
  {
    id: '2',
    name: 'Electricals',
    description: 'Durable electrical components including solenoids, couplers, fuses, fuse boxes, and switches to ensure flawless operation.',
    icon: <Plug size={32} />,
    count: 30,
    image: 'asus_electricals_mzi3em.webp',
    featured: true
  },
  {
    id: '3',
    name: 'Pre-cleaners',
    description: 'Reliable pre-cleaners for engines, air intakes, and filters to boost performance and extend machinery life under harsh conditions.',
    icon: <Filter size={32} />,
    count: 30,
    image: 'asfp1001_lutwwi.webp',
    featured: true
  },
  {
    id: '4',
    name: 'Gear Parts',
    description: 'Precision gears, bearings, and transmission parts designed for smooth, durable, and efficient heavy machinery operation every time.',
    icon: <Cog size={32} />,
    count: 130,
    image: 'asus_gear_cover_j6xtam.webp',
    featured: true
  },
  {
    id: '5',
    name: 'Hydraulic Seal Kits',
    description: 'Top-quality hydraulic seals, gaskets, and O-rings for pumps, cylinders, and systems, ensuring leak-free and reliable performance.',
    icon: <Package size={32} />,
    count: 90,
    image: 'sealkit_cover_1_vq0a9q.webp',
    featured: true
  }
];
